import './spinner.css';

export class Spinner {
	constructor(label?: string) {
		this.element = document.createElement('div');
		this.element.classList.add('spinner');
		this.element.classList.add('hidden');
		this.element.innerHTML = `
		<div class='spinner__bounce-1'></div>
		<div class='spinner__bounce-2'></div>
		<div class='spinner__bounce-3'></div>`;
		if (label) {
			this.element.ariaLabel = label;
			this.element.role = 'img';
		}
	}
	element: HTMLDivElement;

	show = () => {
		this.element.classList.remove('hidden');
	};

	hide = () => {
		this.element.classList.add('hidden');
	};
}
